import { UpdateControleServicosRequest } from "../../../data/daos/update/update_controle_servicos";
import { IUpdateControleServicosUseCase } from "../../../presentation/useCases/update/update_controle_servicos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateControleServicosUseCase
 */

export class UpdateControleServicosUseCase implements IUpdateControleServicosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async updateControleServicos(modal: UpdateControleServicosRequest): Promise<void> {
    const response = await this.repository.updateControleServicos(modal);
    return response;
  }
}
